import { jsx, Fragment } from "react/jsx-runtime";
import { BaseCmsContent } from "./BaseCmsContent.js";
const PageSection = ({
  components,
  ctx
}) => {
  return /* @__PURE__ */ jsx(Fragment, { children: components?.map((cmp, cmpIndex) => {
    return /* @__PURE__ */ jsx(BaseCmsContent, { ctx, data: { ...cmp } }, `${cmpIndex}`);
  }) });
};
export {
  PageSection
};
//# sourceMappingURL=PageSection.js.map
